import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslations from './locales/en/translation.json';
import esTranslations from './locales/es/translation.json';
import deTranslations from './locales/de/translation.json';
import itTranslations from './locales/it/translation.json';
import frTranslations from './locales/fr/translation.json';

i18n
  .use(Backend) // Load translations using http (e.g., from /public/locales)
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    fallbackLng: "en", // Default language
    debug: false, // Enable debugging in development
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    resources: {
      en: {
        translation: enTranslations,
      },
      es: {
        translation: esTranslations,
      },
      de: {
        translation: deTranslations,
      },
      it: {
        translation: itTranslations,
      },
      fr: {
        translation: frTranslations,
      },
    },
  });

export default i18n;
